// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"27ca5dc8","556":"254d1a2f","786":"465da752","836":"1a6aca0a","838":"647f9bd8"}[chunkId] + ".chunk.js";
};